import { graphql } from "gatsby";
import React from "react";

import ApplicationForm from "../../components/forms/applicationForm";
import Layout from "../../components/layout";
import Seo from "../../components/seo";
import { ThemeContext } from "../../context/ThemeContext";
import { useBreakpoint } from "../../hooks";
import heroImgPlaceholder from "../../images/volunteer/hero-img.png";
import { formatHeroBackgroundOptions } from "../../utils/formatContent";

export default function ThankYouForYourApplicationFormPage(props) {
  const { data, location } = props;
  const page = data?.page;
  const details = location?.state || {};

  const breakpoint = useBreakpoint();

  const heroOpts = formatHeroBackgroundOptions(page?.globalConfig);
  // console.debug("ThankYouForYourApplicationFormPage", page.template);
  const heroBackgroundImage =
    breakpoint === "xs"
      ? heroOpts?.image?.mobile ?? heroOpts?.image?.desktop
      : heroOpts?.image?.desktop;

  // console.debug("ThankYouForYourApplicationFormPage", page.template);

  const appformStep = 2;

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page?.title ?? ""}
          containerClass={"w-full mx-auto thank-you-for-your-application"}
          brandingOpts={{ ...theme }}
        >
          <div
            className="relative z-0 bg-center bg-no-repeat bg-cover bg-gray-tertiary planet:bg-gray-dark"
            style={{
              backgroundImage: `url('${heroBackgroundImage}')`
            }}
          >
            <ApplicationForm
              formStep={appformStep}
              details={details}
              theme={theme}
            />
          </div>
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
}

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query {
    page: wpPage(slug: { eq: "thank-you-for-your-application" }) {
      ...basePageFragment
      ...seoPageFragment
      ...WpPage_SeolegacyFragment
      ...translationsPageFragment
      ...translatedPageFragment
      globalConfig {
        backgroundVideo
        backgroundVideoJw
        backgroundImage {
          ...fullwidthFeaturedHeaderImageData
        }
        backgroundImageMobile {
          ...fullwidthFeaturedHeaderImageData
        }
      }
    }
  }
`;
